/**
 * Compile-time exhaustiveness guard.
 *
 * Call this in the `default` branch of a `switch` (or the final `else`) over a
 * discriminated union: TypeScript narrows the value to `never` only when every
 * variant has been handled, so adding a new variant without handling it becomes
 * a compile error. Throws if somehow reached at runtime.
 */
export const assertUnreachable = (value: never): never => {
  throw new Error(`Unhandled case: ${JSON.stringify(value)}`);
};
